import { Injectable } from '@angular/core';
import { StepsType } from '../../shared/types/steps-type';
import { BehaviorSubject, Observable } from 'rxjs';
import { IncotermsIdResponseData } from '@shared/model/incoterms-id-response.model';
import { QuoteRequestResponseData } from '@shared/model/qoute-request-response.model';

@Injectable({
  providedIn: 'root'
})
export class QuotePersistService {
  private serviceTypeId = new BehaviorSubject<number>(2);
  private baseQuoteRequest= new BehaviorSubject<QuoteRequestResponseData>(null);
  private expressStatus = new BehaviorSubject<boolean>(false);
  private incoterms = new BehaviorSubject<IncotermsIdResponseData[]>(null);

  saveToLS(type: StepsType, value) {
    localStorage.setItem(type, JSON.stringify(value));
  }

  getFromLS(type: StepsType) {
    return JSON.parse(localStorage.getItem(type));
  }
  sendServiceTypeId(serviceTypeId: number) {
    this.serviceTypeId.next( serviceTypeId );
  }

  getServiceTypeId(): Observable<number>{
    return this.serviceTypeId.asObservable();
  }
  sendQuoteRequestFields(quoteRequest) {
    this.baseQuoteRequest.next( quoteRequest );
  }
  getQuoteRequestFields(): Observable<QuoteRequestResponseData>{
    return this.baseQuoteRequest.asObservable();
  }
  sendIncoterms(incoterms) {
    this.incoterms.next( incoterms );
  }
  getIncoterms(): Observable<any>{
    return this.incoterms.asObservable();
  }
  sendExpressStatus(status: boolean) {
    this.expressStatus.next( status );
  }
  getExpressStatus(): Observable<boolean>{
    return this.expressStatus.asObservable();
  }
}
